
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from '@/components/ui/toaster';
import { AuthProvider } from './contexts/auth/AuthContext';
import { ThemeProvider } from '@/components/ui/theme-provider';
import { ErrorBoundary } from '@/lib/errors/ErrorBoundary';
import AppRoutes from './routes/AppRoutes';
import { TrackingCodeInjector } from './components/seo/TrackingCodeInjector';
import { HelmetProvider } from 'react-helmet-async';
import ClarityTracker from './components/seo/ClarityTracker';

const App = () => {
  return (
    <ErrorBoundary>
      <HelmetProvider>
        <ThemeProvider defaultTheme="light" storageKey="aluna-theme">
          <BrowserRouter>
            <AuthProvider>
              <div className="overflow-x-hidden w-full">
                <TrackingCodeInjector />
                <ClarityTracker />
                <AppRoutes />
                <Toaster />
              </div>
            </AuthProvider>
          </BrowserRouter>
        </ThemeProvider>
      </HelmetProvider>
    </ErrorBoundary>
  );
};

export default App;
